window.registerOutsideClick = function (modalId, dotNetHelper) {
    document.addEventListener("click", function (event) {
        var modal = document.getElementById(modalId);
        if (modal && !modal.contains(event.target)) {
            dotNetHelper.invokeMethodAsync('CloseModal').catch(err => console.error(err));
        }
    });
};

window.registerOutsideClickDropdown = function (dropdownId, dotNetHelper) {
    document.addEventListener("click", function (event) {
        var dropdown = document.getElementById(dropdownId);
        if (dropdown && !dropdown.contains(event.target)) {
            dotNetHelper.invokeMethodAsync('CloseDropdown').catch(err => console.error(err));
        }
    });
};
